export default "__VITE_PUBLIC_ASSET__f0d4dc17__"